"use client";

import React from "react";
export default function TermsOfUsePage() {
  return <main className="min-h-screen bg-[#FDFAF3] text-[#1C1917]">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.1] [background-image:linear-gradient(to_right,rgba(180,83,9,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(180,83,9,0.1)_1px,transparent_1px)] [background-size:48px_48px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(180,83,9,0.05),transparent_40%),radial-gradient(circle_at_bottom_right,rgba(180,83,9,0.03),transparent_40%)]" />

        <div className="relative mx-auto max-w-5xl px-6 py-20 md:px-8 md:py-24">
          <div className="mb-8 flex items-center gap-4">
            <span className="h-px w-10 bg-[#B45309]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.34em] text-[#B45309]">
              Legal
            </span>
          </div>

          <h1 className="font-serif text-5xl leading-[1] tracking-[-0.03em] text-[#1C1917] md:text-7xl">
            Terms of Use
          </h1>

          <p className="mt-6 max-w-3xl font-serif text-lg leading-8 text-[#1C1917]/70">
            These Terms govern your use of the N2N Capital website and related
            online services. Please review them carefully before accessing or
            using the site.
          </p>

          <div className="mt-12 rounded-2xl border border-[#B45309]/10 bg-[#F5EDD8] p-6 md:p-10 shadow-sm">
            <div className="prose max-w-none prose-headings:font-serif prose-headings:tracking-[-0.02em] prose-headings:text-[#1C1917] prose-p:text-[#1C1917]/80 prose-p:leading-8 prose-strong:text-[#1C1917] prose-li:text-[#1C1917]/80 prose-li:leading-8">
              <h2 className="!mb-4 !mt-0 !text-3xl">N2N Capital Terms of Use</h2>

              <h3 className="!mt-10 !mb-3 !text-2xl">Acceptance of Terms</h3>
              <p>Please read and accept these N2N Capital Terms of Use (“Terms”) before using the [www.n2ncapital.pe] website or any other website maintained by N2N Capital (collectively, the “Website”). By accessing or using the Website, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to all of the Terms, do not use this Website.</p>
              <p>
                N2N Capital may update these Terms from time to time. Each time
                you use the Website, you will be operating under the Terms in
                effect at the time of use. You should review these Terms
                periodically.
              </p>
              <p>
                These Terms are entered into by and between you and N2N
                Capital. If you have a separate written agreement with N2N
                Capital (for example, an investment management agreement or
                subscription agreement), that agreement will govern to the
                extent it conflicts with these Terms.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">Disclaimer</h3>
              <p>
                Although N2N Capital strives to provide accurate and current
                information on the Website, N2N Capital makes no
                representations or warranties as to the completeness, accuracy,
                or timeliness of any information. N2N Capital may change the
                content, services, products, or programs described on the
                Website at any time without notice. Any reference to third-party
                products or services is for information only and does not
                constitute an endorsement or recommendation.
              </p>
              <p>
                <strong>
                  THE MATERIALS AND INFORMATION ON THE WEBSITE ARE PROVIDED “AS
                  IS” AND “AS AVAILABLE,” WITHOUT ANY EXPRESS OR IMPLIED
                  WARRANTY OF ANY KIND, INCLUDING, WITHOUT LIMITATION, WARRANTIES
                  OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
                  AND NON-INFRINGEMENT.
                </strong>
              </p>
              <p>
                <strong>
                  IN NO EVENT SHALL N2N CAPITAL OR ITS AFFILIATES, OFFICERS,
                  DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, OR PARTNERS BE LIABLE
                  FOR ANY DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION,
                  DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR
                  PUNITIVE DAMAGES, OR DAMAGES FOR LOSS OF PROFITS, BUSINESS
                  INTERRUPTION, OR LOSS OF DATA OR INFORMATION) ARISING OUT OF
                  OR IN CONNECTION WITH THE USE OR INABILITY TO USE THE WEBSITE
                  OR THE MATERIALS, EVEN IF N2N CAPITAL HAS BEEN ADVISED OF THE
                  POSSIBILITY OF SUCH DAMAGES.
                </strong>
              </p>
              <p>
                <strong>
                  NOTICE REGARDING ELECTRONIC COMMUNICATIONS PRIVACY: N2N
                  CAPITAL DOES NOT GUARANTEE THE CONFIDENTIALITY OR PRIVACY OF
                  ANY COMMUNICATION OR INFORMATION TRANSMITTED TO OR FROM THE
                  WEBSITE OR ANY SITE LINKED TO THE WEBSITE. N2N CAPITAL WILL
                  NOT BE LIABLE FOR THE PRIVACY OF E-MAIL ADDRESSES,
                  REGISTRATION DATA, IDENTIFICATION INFORMATION, DISK SPACE,
                  COMMUNICATIONS, CONFIDENTIAL OR TRADE-SECRET INFORMATION, OR
                  ANY OTHER CONTENT TRANSMITTED OVER NETWORKS ACCESSED BY THE
                  WEBSITE OR OTHERWISE CONNECTED WITH YOUR USE OF THE WEBSITE OR
                  ANY RELATED SERVICES.
                </strong>
              </p>
              <p>
                Nothing on the Website constitutes investment, legal, tax, or
                other professional advice, or a solicitation or offer to buy or
                sell any security or investment product. Any investment
                decisions should be based on your own independent judgment and,
                where appropriate, consultation with your professional advisers.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">
                Intellectual Property Rights
              </h3>
              <p>
                All content on the Website, including text, data, reports,
                graphics, logos, icons, images, audio clips, video clips,
                software, and other materials (collectively, “Materials”), is
                the property of N2N Capital or its licensors, content
                providers, or other third-party providers (collectively,
                “Third-Party Providers”) and is protected by copyright and other
                intellectual property laws.
              </p>
              <p>
                Except as expressly authorized in writing by N2N Capital or the
                applicable Third-Party Provider, you may not copy, reproduce,
                distribute, republish, download, display, post, transmit,
                create derivative works from, or otherwise exploit any
                Materials in any form or by any means, including electronic,
                mechanical, photocopying, recording, or otherwise. You may not,
                without N2N Capital’s prior express written permission, copy
                any Materials contained on this Website to any other server or
                use any N2N Capital Marks (as defined below) for any purpose.
              </p>
              <p>
                “N2N Capital Marks” means any names, marks, brands, logos,
                designs, slogans, trademarks, service marks, or other
                designations used by N2N Capital in connection with its
                products or services.
              </p>
              <p>
                If you believe that any material on the Website infringes your
                intellectual property rights, you may notify N2N Capital in
                writing. N2N Capital will investigate such complaints and,
                where it determines that an infringement is occurring, take
                appropriate action, which may include removing or disabling
                access to the infringing material.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">Trademarks</h3>
              <p>
                The trademarks, service marks, trade names, and logos
                (collectively, “Marks”) displayed on the Website are the
                property of N2N Capital or third parties. You are not granted
                any license or right to use any Marks without the prior written
                consent of N2N Capital or the applicable third-party owner.
                Unauthorized use of any Marks is strictly prohibited.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">
                Links to Third-Party Sites
              </h3>
              <p>
                The Website may contain links to third-party websites. Access to
                any third-party website linked to the Website is at your own
                risk. N2N Capital is not responsible for, and does not endorse,
                the content, accuracy, or reliability of any information, data,
                opinions, advice, statements, or services made available on or
                through any third-party sites. Links are provided solely as a
                convenience and do not imply any endorsement or approval by N2N
                Capital.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">
                Access to Password-Protected and Secure Areas
              </h3>
              <p>
                Access to and use of password-protected or secure areas of the
                Website is restricted to authorized users only. You may not
                share your login credentials or permit any unauthorized person
                to access these areas. Unauthorized access or attempted access
                to such areas may result in termination of access, and may be
                subject to civil and/or criminal penalties.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">Privacy Policy</h3>
              <p>
                N2N Capital respects your privacy. The collection and use of
                personal information via the Website are governed by N2N
                Capital’s Privacy Policy, which is incorporated into these Terms
                by reference. By using the Website, you consent to the
                processing of your information in accordance with the Privacy
                Policy.
              </p>
              <p>
                You agree not to use the Website or any related services to
                violate the security of any computer network, crack passwords or
                security encryption codes, transfer or store illegal material
                (including content that is threatening, defamatory, obscene, or
                otherwise unlawful), or engage in any illegal activity. You may
                not run mailing lists, listservs, auto-responders, spam, or any
                processes that run or are activated while you are not logged in
                to the Website (if applicable), or otherwise interfere with or
                disrupt the proper working of the Website.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">User Conduct</h3>
              <p>
                You agree to use the Website only for lawful purposes and in
                accordance with these Terms. You agree not to:
              </p>
              <ul>
                <li>
                  Use the Website in any manner that could damage, disable,
                  overburden, or impair any N2N Capital server or network.
                </li>
                <li>
                  Attempt to gain unauthorized access to any part of the
                  Website, other accounts, computer systems, or networks
                  connected to any N2N Capital server.
                </li>
                <li>
                  Use any robot, spider, scraper, or other automated means to
                  access the Website without N2N Capital’s express written
                  permission.
                </li>
              </ul>

              <h3 className="!mt-10 !mb-3 !text-2xl">
                Governing Law and Jurisdiction
              </h3>
              <p>These Terms and your use of the Website shall be governed by and construed in accordance with the laws of the State of Delaware, without giving effect to any choice-of-law or conflict-of-law provisions. You agree to submit to the exclusive jurisdiction of the state and federal courts located in the State of Delaware for the resolution of any disputes arising out of or relating to these Terms or the Website.</p>

              <h3 className="!mt-10 !mb-3 !text-2xl">
                Changes and Termination
              </h3>
              <p>
                N2N Capital reserves the right, at any time and without notice,
                to modify, suspend, or discontinue all or any portion of the
                Website, or to terminate or restrict your access to the Website,
                for any reason or no reason. N2N Capital shall not be liable to
                you or any third party for any such modification, suspension,
                discontinuation, or termination.
              </p>

              <h3 className="!mt-10 !mb-3 !text-2xl">
                Entire Agreement and Severability
              </h3>
              <p>
                These Terms, together with any other notices, policies, or
                disclaimers posted on the Website and any separate written
                agreement you may have with N2N Capital, constitute the entire
                agreement between you and N2N Capital regarding your use of the
                Website. If any provision of these Terms is held to be invalid
                or unenforceable, that provision will be enforced to the maximum
                extent permissible, and the remaining provisions will remain in
                full force and effect.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}